import { UseFormReturn } from "react-hook-form";
import { DTOModule } from "../../types/building";
import SelectEditor from "../Global/Editors/SelectEditor";
import { nameof } from "../Global/Utils";
import { IModuleVentilationS } from "../../types/ModuleDatas";
import NumberEditor from "../Global/Editors/NumberEditor";
import { MapTooltip } from "../../types/globalData";

interface IProps {
  module: DTOModule;
  data: any;
  formHook: UseFormReturn;
}

// ärSjälvdragsystemetHelaByggnaden: "Ja" | "Nej";
// betjänasAndel: number;

const ConfigVentilationS = ({ module, data, formHook }: IProps) => {
  const ärSjälvdragsystemetHelaByggnaden = formHook.watch("ärSjälvdragsystemetHelaByggnaden");

  return (
    <>
      <div className="row d-flex align-items-baseline gy-0">
        <div className="col-12">
          <SelectEditor
            label="Betjänar självdragsystemet hela byggnaden? Ja/Nej"
            fieldName={nameof<IModuleVentilationS>("ärSjälvdragsystemetHelaByggnaden")}
            tooltipId={nameof<MapTooltip>("VentilationS_ärSjälvdragsystemetHelaByggnaden")}
            items={["Ja", "Nej"]}
            formHook={formHook}
          />
        </div>
        <div className="col-12">
          <NumberEditor
            label="Hur stor andel av byggnadens yta betjänas av självdragssystemet (Procent)?"
            fieldName={nameof<IModuleVentilationS>("betjänasAndel")}
            tooltipId={nameof<MapTooltip>("VentilationS_betjänasAndel")}
            formHook={formHook}
            isDisabled={ärSjälvdragsystemetHelaByggnaden !== "Nej"}
            min={0}
            max={100}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Ange andel" : undefined;
                },
              },
            }}
          />
        </div>
        {/* {ärSjälvdragsystemetHelaByggnaden === "Nej" ? (
      ) : (
        <></>
      )} */}
      </div>
    </>
  );
};

export default ConfigVentilationS;
